import React, { useState, useEffect, useCallback } from 'react';
import cl from './ProgressStudent.module.css';
import AdminService from '../../API/AdminService';
import Spinner from '../../components/UI/Spinner/Spinner';
import { FOLDER_PROFILE, FOLDER_PROJECT_RT } from '../../API/API';
import ava from './img/ava.png';
import logger from '../../utils/logger';
import PageIntro from '../../components/PageIntro/PageIntro';
import {
    IconChart, IconSearch, IconClose, IconRefresh, IconCheck, IconClock,
    IconStudents, IconDiamond, IconStar, IconTrophy, IconBook,
} from '../../components/Icons';
const projectRoboTehnick = [
    { id: 1, title: 'Фонарик брелок', desc: 'Схема фонарике в корпусе из 2 крышек', ratingCount: 3, diamondCount: 3 },
    { id: 2, title: 'Колесо фортуны', desc: 'Крутится диск и выпадает случайное число', ratingCount: 5, diamondCount: 5 },
    { id: 3, title: 'Игра - не касайся!', desc: 'Проведи рукой по лабиринту не касаясь его', ratingCount: 6, diamondCount: 6 },
    { id: 4, title: 'Робот жук', desc: 'Два уса, 3 колеса - катается по полу', ratingCount: 8, diamondCount: 8 },
    { id: 5, title: 'Сигнализация на герконе', desc: 'Сигнализация, которая срабатывает при разрыве магнита', ratingCount: 10, diamondCount: 10 },
    { id: 6, title: 'Сигнализация на колодке', desc: 'Сигнализация, которая срабатывает на обрыв провода', ratingCount: 10, diamondCount: 10 },
    { id: 7, title: 'Факел из майна', desc: 'Ночник - факел из майнкрафта', ratingCount: 8, diamondCount: 8 },
    { id: 8, title: 'Колонка v1', desc: 'Колонка на транзисторе по технологиям дедов', ratingCount: 10, diamondCount: 10 },
    { id: 9, title: 'Ковырялка в носу', desc: 'Светильник - мини джедайский меч', ratingCount: 10, diamondCount: 10 },
    { id: 10, title: 'Мультивибратор', desc: 'Кулон, который перемигивается на макетке', ratingCount: 12, diamondCount: 12 },
    { id: 11, title: 'Песочные часы', desc: 'Пайка на плате - электронные песочные часы', ratingCount: 14, diamondCount: 14 },
    { id: 12, title: 'Радио', desc: 'Пайка на плате - полнофункциональное мини радио', ratingCount: 16, diamondCount: 16 },
    { id: 13, title: 'Колонка v2', desc: 'Колонка на микросхеме - технологии 2010 года', ratingCount: 12, diamondCount: 12 },
    { id: 14, title: 'Игра лабиринт', desc: 'Прокати шарик по лабиринту, не попав в ловушки', ratingCount: 14, diamondCount: 14 },
    { id: 15, title: 'Колесо-кричалка', desc: 'Колесо фортуны, крутящееся пока на него кричишь', ratingCount: 12, diamondCount: 12 },
    // Остальные проекты...
    { id: 16, title: 'Проект 16', desc: 'Описание проекта 16', ratingCount: 15, diamondCount: 15 },
    { id: 17, title: 'Проект 17', desc: 'Описание проекта 17', ratingCount: 16, diamondCount: 16 },
    { id: 18, title: 'Проект 18', desc: 'Описание проекта 18', ratingCount: 17, diamondCount: 17 },
    { id: 19, title: 'Проект 19', desc: 'Описание проекта 19', ratingCount: 18, diamondCount: 18 },
    { id: 20, title: 'Проект 20', desc: 'Описание проекта 20', ratingCount: 19, diamondCount: 19 },
    { id: 21, title: 'Проект 21', desc: 'Описание проекта 21', ratingCount: 20, diamondCount: 20 },
    { id: 22, title: 'Проект 22', desc: 'Описание проекта 22', ratingCount: 21, diamondCount: 21 },
    { id: 23, title: 'Проект 23', desc: 'Описание проекта 23', ratingCount: 22, diamondCount: 22 },
    { id: 24, title: 'Проект 24', desc: 'Описание проекта 24', ratingCount: 23, diamondCount: 23 },
    { id: 25, title: 'Проект 25', desc: 'Описание проекта 25', ratingCount: 24, diamondCount: 24 },
    { id: 26, title: 'Проект 26', desc: 'Описание проекта 26', ratingCount: 25, diamondCount: 25 },
    { id: 27, title: 'Проект 27', desc: 'Описание проекта 27', ratingCount: 26, diamondCount: 26 },
    { id: 28, title: 'Проект 28', desc: 'Описание проекта 28', ratingCount: 27, diamondCount: 27 },
    { id: 29, title: 'Проект 29', desc: 'Описание проекта 29', ratingCount: 28, diamondCount: 28 },
    { id: 30, title: 'Проект 30', desc: 'Описание проекта 30', ratingCount: 29, diamondCount: 29 }
];

const ProgressStudent = () => {
    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [stats, setStats] = useState({
        totalStudents: 0,
        averageProgress: 0,
        totalProjects: 0,
        completedProjects: 0
    });

    // Функция для получения информации о проекте по ID
    const getProjectInfo = useCallback((projectId) => {
        return projectRoboTehnick.find(p => p.id === parseInt(projectId)) || {
            id: projectId,
            title: `Проект ${projectId}`,
            desc: 'Описание недоступно',
            ratingCount: 0,
            diamondCount: 0
        };
    }, []);

    // Загрузка прогресса учеников — ОДНИМ запросом к бэку.
    // Эндпоинт /api/v1/admin/robotehnick/aggregate?filter=approved возвращает:
    //   - accounts: только те, где есть принятые задания (taskRobotehnikAprowe не пуст),
    //     с уже распарсенным approvedTasks (без JSON.parse на фронте).
    //   - students: { id → {id, firstName, lastName, age, group} } — только тех,
    //     кого реально нужно отрендерить.
    //   - minecraftia: { id → {id, firstName, photo, level, diamond, rating} } — один
    //     bulk-вызов в user-сервис внутри бэка.
    //
    // Это заменяет: getAllAccountStudents + getAllStudents + getProfilesBulk (3 запроса
    // плюс fallback до 200+ запросов при сбое условия проверки .success).
    const loadStudentsProgress = useCallback(async () => {
        try {
            setLoading(true);
            setError('');

            const resp = await AdminService.getRobotehnickAggregate('approved');
            if (!resp?.success) {
                setError('Ошибка загрузки данных аккаунтов');
                return;
            }

            const { accounts, students: studentsMap, minecraftia } = resp.data;

            const studentsWithProgress = [];
            let totalProjects = 0;
            let completedProjects = 0;

            for (const account of accounts) {
                const student = studentsMap[account.idStudent];
                if (!student) continue;

                const approvedTasks = account.approvedTasks || [];
                const progress = approvedTasks.length;
                totalProjects += 30;
                completedProjects += progress;

                const minecraftUser = account.idUserMinecraftia
                    ? (minecraftia[account.idUserMinecraftia] || null)
                    : null;

                studentsWithProgress.push({
                    id: student.id,
                    firstName: student.firstName,
                    lastName: student.lastName,
                    age: student.age,
                    group: student.group,
                    progress,
                    progressPercent: Math.round((progress / 30) * 100),
                    approvedTasks,
                    accountId: account.id,
                    minecraftUser,
                    accountData: account,
                });
            }

            const averageProgress = studentsWithProgress.length > 0
                ? Math.round(studentsWithProgress.reduce((sum, s) => sum + s.progress, 0) / studentsWithProgress.length)
                : 0;

            setStats({
                totalStudents: studentsWithProgress.length,
                averageProgress,
                totalProjects,
                completedProjects,
            });

            setStudents(studentsWithProgress);
        } catch (error) {
            logger.error('Ошибка загрузки прогресса студентов:', error);
            setError('Ошибка загрузки данных: ' + (error?.message || error));
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        loadStudentsProgress();
    }, [loadStudentsProgress]);

    // Фильтрация студентов по поиску
    const filteredStudents = students.filter(student => {
        const searchLower = searchTerm.toLowerCase();
        return (
            student.firstName.toLowerCase().includes(searchLower) ||
            student.lastName.toLowerCase().includes(searchLower) ||
            student.group.toLowerCase().includes(searchLower)
        );
    });

    // Открытие модального окна с деталями
    const openDetailModal = useCallback((student) => {
        setSelectedStudent(student);
        setShowDetailModal(true);
    }, []);

    // Закрытие модального окна
    const closeDetailModal = useCallback(() => {
        setShowDetailModal(false);
        setSelectedStudent(null);
    }, []);

    // Функция для получения статуса проекта
    const getProjectStatus = useCallback((projectId, approvedTasks) => {
        const task = approvedTasks.find(task =>
            Array.isArray(task) && task.length >= 1 && parseInt(task[0]) === projectId
        );
        if (task) {
            return {
                completed: true,
                image: task[1] || null,
                completedAt: task[2] || null
            };
        }
        return { completed: false, image: null, completedAt: null };
    }, []);

    if (loading) {
        return <Spinner size="large" text="Загрузка прогресса учеников" fullPage />;
    }

    if (error) {
        return (
            <div className={cl.errorContainer}>
                <div className={cl.errorMessage}>
                    <h3>Произошла ошибка</h3>
                    <p>{error}</p>
                    <button
                        className={cl.retryButton}
                        onClick={() => {
                            setError('');
                            loadStudentsProgress();
                        }}
                    >
                        Повторить попытку
                    </button>
                </div>
            </div>
        );
    }

    const completedPercent = stats.totalProjects > 0
        ? Math.round((stats.completedProjects / stats.totalProjects) * 100)
        : 0;

    return (
        <div className={cl.page_wrapper}>
            <div className={cl.wrap_content_1}>
                {/* Шапка-карточка */}
                <div className={cl.pageHeaderV2}>
                    <div className={cl.pageHeaderLeft}>
                        <div className={cl.pageHeaderIcon}>
                            <IconChart width={22} height={22}/>
                        </div>
                        <div className={cl.pageHeaderText}>
                            <div className={cl.pageHeaderTopRow}>
                                <h1 className={cl.pageHeaderTitle}>Прогресс учеников</h1>
                                <span className={cl.pageHeaderPill}>
                                    <span className={cl.pageHeaderPillStrong}>{stats.totalStudents}</span>
                                    <span className={cl.pageHeaderPillMuted}>
                                        {stats.totalStudents === 1 ? 'ученик' : 'учеников'}
                                    </span>
                                </span>
                                <span className={`${cl.pageHeaderPill} ${cl.pageHeaderPillSuccess}`}>
                                    <span className={cl.pageHeaderPillStrong}>{completedPercent}%</span>
                                    <span className={cl.pageHeaderPillMuted}>выполнено</span>
                                </span>
                            </div>
                            <div className={cl.breadcrumbs}>
                                АдминПанель · Робототехника · Прогресс учеников
                            </div>
                        </div>
                    </div>
                    <div className={cl.pageHeaderActions}>
                        <button
                            onClick={loadStudentsProgress}
                            className={cl.btnGhostV2}
                            title="Обновить"
                        >
                            <IconRefresh width={15} height={15}/>
                        </button>
                    </div>
                </div>

                <PageIntro
                    storageKey="progress-student"
                    title="О странице «Прогресс учеников»"
                    text="Сводка по тому, как ученики продвигаются по программе РобоТехники: сколько из 30 проектов первого уровня уже принято. Сюда попадают только ученики, у которых есть хотя бы один зачтённый проект — остальные пока не начали."
                    bullets={[
                        'Поиск работает по имени, фамилии или группе',
                        'Клик на карточку — полный список из 30 проектов с фото уже сданных',
                        'Зачёт проекта добавляется через раздел «Проверка проектов»',
                        'KPI сверху показывают общую картину по центру: среднее, доля выполненного',
                    ]}
                />

                {/* KPI карточки */}
                <div className={cl.statsContainer}>
                    <div className={`${cl.statCard} ${cl.statCardAccent}`}>
                        <div className={cl.statTop}>
                            <span className={cl.statIcon}>
                                <IconStudents width={18} height={18}/>
                            </span>
                            <div className={cl.statLabel}>Всего учеников</div>
                        </div>
                        <div className={cl.statNumber}>{stats.totalStudents}</div>
                        <div className={cl.statSubLabel}>с принятыми проектами</div>
                    </div>
                    <div className={cl.statCard}>
                        <div className={cl.statTop}>
                            <span className={cl.statIcon}>
                                <IconTrophy width={18} height={18}/>
                            </span>
                            <div className={cl.statLabel}>Средний прогресс</div>
                        </div>
                        <div className={cl.statNumber}>{stats.averageProgress}</div>
                        <div className={cl.statSubLabel}>проектов на ученика</div>
                    </div>
                    <div className={cl.statCard}>
                        <div className={cl.statTop}>
                            <span className={cl.statIcon}>
                                <IconCheck width={18} height={18}/>
                            </span>
                            <div className={cl.statLabel}>Выполнено проектов</div>
                        </div>
                        <div className={cl.statNumber}>{stats.completedProjects}</div>
                        <div className={cl.statSubLabel}>{completedPercent}% от всего</div>
                    </div>
                    <div className={cl.statCard}>
                        <div className={cl.statTop}>
                            <span className={cl.statIcon}>
                                <IconBook width={18} height={18}/>
                            </span>
                            <div className={cl.statLabel}>Всего проектов</div>
                        </div>
                        <div className={cl.statNumber}>{stats.totalProjects}</div>
                        <div className={cl.statSubLabel}>30 проектов · 1 уровень</div>
                    </div>
                </div>

                {/* Поиск */}
                <div className={cl.searchContainerV2}>
                    <span className={cl.searchIconV2}>
                        <IconSearch width={18} height={18}/>
                    </span>
                    <input
                        type="text"
                        placeholder="Поиск по имени или группе…"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className={cl.searchInputV2}
                    />
                    {searchTerm && (
                        <button
                            className={cl.clearSearchV2}
                            onClick={() => setSearchTerm('')}
                            aria-label="Очистить"
                        >
                            <IconClose width={14} height={14}/>
                        </button>
                    )}
                </div>

                {/* Список учеников */}
                {filteredStudents.length === 0 ? (
                    <div className={cl.emptyState}>
                        <h3>Ученики не найдены</h3>
                        <p>Нет учеников с выполненными проектами или они не соответствуют поиску</p>
                    </div>
                ) : (
                    <div className={cl.studentsGrid}>
                        {filteredStudents.map((student) => (
                            <div
                                key={student.id}
                                className={cl.studentCard}
                                onClick={() => openDetailModal(student)}
                            >
                                {/* Основная информация */}
                                <div className={cl.studentHeader}>
                                    <div className={cl.studentInfo}>
                                        <h3 className={cl.studentName}>
                                            {student.firstName} {student.lastName}
                                        </h3>
                                        <p className={cl.studentDetails}>
                                            {student.age} лет • Группа: {student.group}
                                        </p>
                                    </div>
                                </div>

                                {/* Minecraft аккаунт */}
                                {student.minecraftUser && (
                                    <div className={cl.minecraftInfo}>
                                        <div className={cl.minecraftAvatar}>
                                            {student.minecraftUser.photo ? (
                                                <img
                                                    className={cl.minecraftAvatarimg}
                                                    style={{width:48,height:48,borderRadius:50}}
                                                    src={`${FOLDER_PROFILE}${student.minecraftUser.photo}`}
                                                    alt={student.minecraftUser.firstName}
                                                    onError={(e) => {
                                                        e.target.src = ava;
                                                    }}
                                                />
                                            ) : (
                                                <img className={cl.minecraftAvatarimg} src={ava} alt="Аватар" />
                                            )}
                                        </div>
                                        <div className={cl.minecraftDetails}>
                                            <div className={cl.minecraftName}>
                                                {student.minecraftUser.firstName}
                                            </div>
                                            <div className={cl.minecraftStats}>
                                                <span className={cl.minecraftStat}>
                                                    <IconStar width={12} height={12}/>
                                                    {student.minecraftUser.level || 0}
                                                </span>
                                                <span className={cl.minecraftStat}>
                                                    <IconDiamond width={12} height={12}/>
                                                    {student.minecraftUser.diamonds || 0}
                                                </span>
                                                <span className={cl.minecraftStat}>
                                                    <IconTrophy width={12} height={12}/>
                                                    {student.minecraftUser.rating || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* Прогресс */}
                                <div className={cl.progressSection}>
                                    <div className={cl.progressHeader}>
                                        <span className={cl.progressText}>
                                            Прогресс: {student.progress} из 30
                                        </span>
                                        <span className={cl.progressPercent}>
                                            {student.progressPercent}%
                                        </span>
                                    </div>
                                    <div className={cl.progressBar}>
                                        <div
                                            className={cl.progressFill}
                                            style={{ width: `${student.progressPercent}%` }}
                                        ></div>
                                    </div>
                                </div>

                                <div className={cl.cardFooter}>
                                    <span className={cl.clickHint}>
                                        Нажмите для подробной информации
                                    </span>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* Модальное окно с деталями */}
                {showDetailModal && selectedStudent && (
                    <div className={cl.modalOverlay} onClick={closeDetailModal}>
                        <div className={cl.modal} onClick={(e) => e.stopPropagation()}>
                            <div className={cl.modalHeader}>
                                <div className={cl.modalTitleWrap}>
                                    <span className={cl.modalTitleIcon}>
                                        <IconChart width={18} height={18}/>
                                    </span>
                                    <h2>
                                        {selectedStudent.firstName} {selectedStudent.lastName}
                                    </h2>
                                </div>
                                <button onClick={closeDetailModal} className={cl.closeButton} aria-label="Закрыть">
                                    <IconClose width={18} height={18}/>
                                </button>
                            </div>

                            <div className={cl.modalContent}>
                                {/* Контактные данные */}
                                <div className={cl.modalSection}>
                                    <h3>Контактная информация</h3>
                                    <div className={cl.contactInfo}>
                                        <p><strong>Возраст:</strong> {selectedStudent.age} лет</p>
                                        <p><strong>Группа:</strong> {selectedStudent.group}</p>
                                        <p><strong>Прогресс:</strong> {selectedStudent.progress} из 30 проектов ({selectedStudent.progressPercent}%)</p>

                                        {/* Minecraft аккаунт */}
                                        {selectedStudent.minecraftUser && (
                                            <div className={cl.minecraftFullInfo}>
                                                <h4>Аккаунт Minecraft</h4>
                                                <div className={cl.minecraftProfile}>
                                                    <div className={cl.minecraftAvatar}>
                                                        {selectedStudent.minecraftUser.photo ? (
                                                            <img
                                                                style={{width:48,borderRadius:50,height:48}}
                                                                src={`${FOLDER_PROFILE}${selectedStudent.minecraftUser.photo}`}
                                                                alt={selectedStudent.minecraftUser.firstName}
                                                                onError={(e) => {
                                                                    e.target.src = ava;
                                                                }}
                                                            />
                                                        ) : (
                                                            <img src={ava} alt="Аватар" />
                                                        )}
                                                    </div>
                                                    <div className={cl.minecraftDetails}>
                                                        <p><strong>Никнейм:</strong> {selectedStudent.minecraftUser.firstName}</p>
                                                        <div className={cl.minecraftStatsGrid}>
                                                            <span>Уровень: {selectedStudent.minecraftUser.level || 0}</span>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Список проектов */}
                                <div className={cl.modalSection}>
                                    <h3>Проекты (30 штук)</h3>
                                    <div className={cl.projectsGrid}>
                                        {projectRoboTehnick.map((project) => {
                                            const projectStatus = getProjectStatus(project.id, selectedStudent.approvedTasks);
                                            return (
                                                <div
                                                    key={project.id}
                                                    className={`${cl.projectItem} ${projectStatus.completed ? cl.completed : cl.notCompleted}`}
                                                >
                                                    <div className={cl.projectNumber}>
                                                        {project.id}
                                                    </div>
                                                    <div className={cl.projectContent}>
                                                        <h4 className={cl.projectTitle}>
                                                            {project.title}
                                                        </h4>
                                                        <p className={cl.projectDesc}>
                                                            {project.desc}
                                                        </p>

                                                        {projectStatus.completed ? (
                                                            <div className={cl.projectCompleted}>
                                                                <div className={cl.completedStatus}>
                                                                    <IconCheck width={12} height={12}/>
                                                                    <span>Выполнено</span>
                                                                </div>
                                                                {projectStatus.image && (
                                                                    <div className={cl.projectImage}>
                                                                        <img
                                                                            src={`${FOLDER_PROJECT_RT}${projectStatus.image}`}
                                                                            alt={project.title}
                                                                            onError={(e) => {
                                                                                e.target.style.display = 'none';
                                                                                e.target.nextSibling.style.display = 'block';
                                                                            }}
                                                                        />
                                                                        <div className={cl.imageError} style={{ display: 'none' }}>
                                                                            Изображение недоступно
                                                                        </div>
                                                                    </div>
                                                                )}
                                                                <div className={cl.projectRewards}>
                                                                    <span className={cl.reward}>
                                                                        <IconDiamond width={12} height={12}/>
                                                                        {project.diamondCount}
                                                                    </span>
                                                                    <span className={cl.reward}>
                                                                        <IconStar width={12} height={12}/>
                                                                        {project.ratingCount}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className={cl.projectNotCompleted}>
                                                                <div className={cl.notCompletedStatus}>
                                                                    <IconClock width={12} height={12}/>
                                                                    <span>Не выполнено</span>
                                                                </div>
                                                                <div className={cl.expectedRewards}>
                                                                    <span className={cl.reward}>
                                                                        <IconDiamond width={12} height={12}/>
                                                                        {project.diamondCount}
                                                                    </span>
                                                                    <span className={cl.reward}>
                                                                        <IconStar width={12} height={12}/>
                                                                        {project.ratingCount}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProgressStudent;